var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrefixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6633 17.5866C15.8394 17.7627 15.9383 18.0016 15.9383 18.2507C15.9383 18.4997 15.8394 18.7386 15.6633 18.9147C15.4871 19.0908 15.2483 19.1898 14.9992 19.1898C14.7501 19.1898 14.5112 19.0908 14.3351 18.9147L8.08513 12.6647C7.99773 12.5776 7.92838 12.4741 7.88106 12.3602C7.83374 12.2462 7.80939 12.124 7.80939 12.0006C7.80939 11.8773 7.83374 11.7551 7.88106 11.6411C7.92838 11.5272 7.99773 11.4237 8.08513 11.3366L14.3351 5.08659C14.5112 4.91047 14.7501 4.81152 14.9992 4.81152C15.2483 4.81152 15.4871 4.91047 15.6633 5.08659C15.8394 5.26271 15.9383 5.50158 15.9383 5.75065C15.9383 5.99972 15.8394 6.23859 15.6633 6.41471L10.0781 11.9999L15.6633 17.5866Z",
    fill: "#0AB39C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrefixIcon);
export default __webpack_public_path__ + "static/media/PrefixIcon.cb07f660e7b409fcac88ca6bb2bc5daf.svg";
export { ForwardRef as ReactComponent };